export default "__VITE_ASSET__CoP2$EIH__"